<template>
  <v-card class="pa-3" outlined style="border-radius: 6px; height: 100%">
    <div class="pa-2 grey lighten-2" style="border-radius: 6px">
      <strong>{{ $t('Progresso Manutenção Programada - Mês Vigente') }}</strong>
    </div>

    <BarChart :chart-data="chartData" :options="options" />
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import BarChart from '../../Reports/components/charts/barChart'

export default {
  name: 'ScheduleComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
    institutionIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
    institutionIds() {
      this.filter.institutionIds = this.institutionIds
    },
  },

  components: {
    BarChart,
  },

  data() {
    return {
      options: {
        legend: {
          display: false,
        },
      },
      apiService: new ApiService(),
      filter: {
        page: 1,
        pageSize: 10,
        unidadeIds: [],
        departmentIds: [],
        institutionIds: [],
        institutionId: 1,
      },
      chartData: {},
      chartData2: {},
      data: {
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    list() {
      this.apiService.post('dash/schedule', this.filter).then((response) => {
        this.data = response.content
        this.chartData = {
          labels: [
            'Internas (executado)',
            'Internas (agendado)',
            'Total (executado)',
            'Total (agendado)',
          ],
          datasets: [
            {
              label: 'Total',
              data: [
                this.data.internalExecuted,
                this.data.internalSchedule,
                this.data.totalExecuted,
                this.data.totalSchedule,
              ],
              backgroundColor: ['orange', '#bbcf20', '#0288d1', '#aaa'],
              pointRadius: 5,
              pointHoverRadius: 10,
            },
          ],
        }
      })
    },
  },
}
</script>

<style scoped></style>
